<template>
  <div>
    <top-header-info></top-header-info>
    <top-logo state="1"></top-logo>
    <right-nav></right-nav>
    <home-nav></home-nav>
    <div>
      <div class="w">
        <div class="site-nav">
          <router-link :to="{name:'index'}">首页</router-link>>
          <router-link :to="{name:'user-center'}">个人中心</router-link>> 订单详情
        </div>
        <left-userinfo state="4"></left-userinfo>
        <div class="right-detail-wrap">
          <div class="top-info">
            <el-row :gutter="20">
              <el-col :span="8">订单编号：{{orderInfo.id}}</el-col>
              <el-col :span="12">收货人：{{orderInfo.name}}</el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                订单状态：
                <span class="big_word">{{orderInfo.status}}</span>
              </el-col>
              <el-col :span="12">手机号码：{{orderInfo.phone}}</el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">下单时间：{{orderInfo.created_at}}</el-col>
            </el-row>
          </div>
          <table class="orderlist-title-wrapper" cellspacing="0">
            <thead>
              <tr>
                <th class="orderlist-title-name">场地</th>
                <th class="orderlist-title-money">项目</th>
                <th class="orderlist-title-date">日期</th>
                <th class="orderlist-title-times">场次</th>
                <th class="orderlist-title-total">合计</th>
              </tr>
            </thead>
            <tbody class="user-order-list">
              <tr class="user-order-item">
                <td class="user-order-name">
                  <el-row>
                    <el-col
                      @click.native="gotoProduct(orderInfo.qu_yun_dong_order[0].venues_id,orderInfo.qu_yun_dong_order[0].cat_id)"
                    >
                      <img
                        alt="商品图片"
                        align="center"
                        :src="quYunDongOrder[0] && quYunDongOrder[0].venues_img_url?quYunDongOrder[0].venues_img_url:goodsDefault"
                      > &nbsp;
                      <a
                        href="javascript:void(0)"
                      >{{quYunDongOrder[0] && quYunDongOrder[0].venues_name}}</a>
                    </el-col>
                  </el-row>
                </td>
                <td>{{quYunDongOrder[0] && quYunDongOrder[0].category.cat_name}}</td>
                <td
                  class="date-td"
                >{{quYunDongOrder[0]&& quYunDongOrder[0].date | dateFormat3}}({{quYunDongOrder[0] && quYunDongOrder[0].date | dayFormat2}})</td>
                <td class="times-td">
                  <div v-for="i in quYunDongOrder" :key="i.id">
                    {{i.field_name}}：
                    <span>{{i.time}}-{{i.end_time}} {{i.price | intYuan}}</span>
                  </div>
                </td>
                <td class="user-order-operation red_word">{{orderInfo.total | yuan}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <bottom-content></bottom-content>
  </div>
</template>
<script>
import TopHeaderInfo from "@/components/top-header-info";
import TopLogo from "@/components/top-logo";
import RightNav from "@/components/right-nav";
import BottomContent from "@/components/bottom-content";
import HomeNav from "@/components/home-nav";
import LeftUserinfo from "@/components/left-userinfo";
import GOODSDEFAULT from "@/assets/images/goods_default.jpg";
export default {
  components: {
    TopHeaderInfo,
    TopLogo,
    RightNav,
    BottomContent,
    HomeNav,
    LeftUserinfo
  },
  data() {
    return {
      orderInfo: "",
      quYunDongOrder: "",
      delivery: [],
      reverse: true,
      goodsDefault: GOODSDEFAULT
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$reqGet(
        "api/store/quyundong_order/" + this.$route.params.order_id
      ).then(res => {
        this.orderInfo = res.data.data.order;
        this.quYunDongOrder = this.orderInfo.qu_yun_dong_order;
        console.log(this.quYunDongOrder)
      });
    },
    getDeliveryInfo(product, index) {
      if (!product.showDelivery) {
        this.$set(product, "showDelivery", true);
      } else {
        this.$set(product, "showDelivery", false);
      }

      this.$reqGet("api/store/express/" + product.id).then(res => {
        let data = res.data.data;
        this.$set(this.delivery, index, data);
      });
    },
    gotoProduct(id, cat_id) {
      this.$router.push({
        name: "qyd-detail",
        query: { veneus_id: id, cate_id: cat_id }
      });
    },
    askServe(id, supplier) {
      this.$router.push({
        name: "refund-submit",
        params: { product_id: id },
        query: { supplier: supplier }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.site-nav {
  padding: 20px 0;
  color: #999;
  font-size: 16px;
  a {
    color: #999;
  }
  a:first-child {
    color: #444;
  }
}
.right-detail-wrap {
  position: relative;
  margin-bottom: 40px;
  min-height: 572px;
  width: 980px;
  left: 220px;
  box-sizing: border-box;
  padding: 22px 25px 60px;
  background-color: #fff;
  .top-info {
    .el-col {
      line-height: 36px;
      border-bottom: 1px solid #f0f0f0;
      margin: 0 10px;
      box-sizing: border-box;
    }
  }
  .orderlist-title-wrapper {
    text-align: center;
    box-sizing: border-box;
    background-color: #fbfbfb;
    border: 1px solid #f5f5f5;
    margin: 20px 0;
    th {
      width: 162px;
      height: 40px;
      line-height: 40px;
      color: #222222;
    }
    .orderlist-title-name {
      width: 260px;
    }
    .orderlist-title-times {
      width: 300px;
    }
  }
  .user-order-list {
    background-color: #fff;
    td {
      height: 105px;
      text-align: center;
      vertical-align: middle;
      box-sizing: border-box;
    }
    .user-order-name {
      width: 350px !important;
      box-sizing: border-box;
      text-align: left;
      overflow: hidden;
      padding-left: 10px;
      border-left: none;
      img {
        width: 60px;
        height: 60px;
        cursor: pointer;
      }
      .user-order-product-title {
        text-align: left;
        height: 57px;
        color: #222;
        display: -webkit-box;
        text-overflow: ellipsis;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        cursor: pointer;
      }
      .user-order-product-count {
        line-height: 57px;
        text-align: right;
        color: #999;
      }
    }
    .date-td {
      white-space: nowrap;
    }
    .times-td {
      line-height: 26px;
    }
  }
}
.red_word {
  color: #fc0010;
}
.big_word {
  font-size: 20px;
  color: #e2333f;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/qyd-order-detail.vue